import { useMemo } from 'react';
import { useItemsStore } from '../store';
import { Category, Product } from '../interfaces/domain/menu';

export const useMainPlates = () => {
    // 1. SELECTORES ATÓMICOS
    // Solo escuchamos categorías y features. Ignoramos cambios en info del restaurante.
    const categories = useItemsStore(state => state.menuData?.categories);
    const featuresData = useItemsStore(state => state.featuresData);

    // 2. PROCESAMIENTO MEMOIZADO
    const sections = useMemo(() => {
        if (!categories || !featuresData) return [];

        // --- OPTIMIZACIÓN 1: Aplanado eficiente ---
        const getAllAvailableProducts = (cats: Category[]): Product[] => {
            const all: Product[] = [];
            const stack = [...cats];
            
            while (stack.length > 0) {
                const cat = stack.pop()!;
                if (cat.products) {
                    // Solo agregamos los disponibles de una vez
                    for (const p of cat.products) {
                        if (p.is_available) all.push(p);
                    }
                }
                if (cat.subcategories?.length) {
                    stack.push(...cat.subcategories);
                }
            }
            return all;
        };

        const allAvailable = getAllAvailableProducts(categories);

        // --- OPTIMIZACIÓN 2: Búsqueda por Mapa (O(1)) ---
        // Crear un mapa ID -> Producto para que la búsqueda de features sea instantánea
        const productMap = new Map(allAvailable.map(p => [p.id, p]));

        return [...featuresData]
            .sort((a, b) => (a.priority ?? 999) - (b.priority ?? 999))
            .map(feature => ({
                title: feature.name,
                products: feature.items
                    .map(id => productMap.get(id)) // Búsqueda directa en el mapa
                    .filter((p): p is Product => !!p) 
            }))
            .filter(section => section.products.length > 0);
            
    }, [categories, featuresData]);

    return {
        sections,
        hasData: sections.length > 0
    };
};